<template>
  <v-sheet color="pink lighten-4" rounded
    ><p style="padding: 8px" class="text-caption">
      Tidak ada event tersedia saat ini
    </p>
  </v-sheet>
</template>

<script>
export default {
  name: 'EmpytState',
};
</script>

<style scoped></style>
